import React, { useContext } from "react";
import {
    Button,
    Container,
    Col,
    Row,
    Table,
    Alert
} from "react-bootstrap";

import Guest from "../../../layouts/Guest";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faTicket, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { createEvent } from 'ics';
import {
    Card, CardBody, CardSubtitle
} from 'reactstrap';
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import { useGuestContext } from "../../../contexts/GuestContext";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import cuteVege1 from "../../../assets/img/baolinPrivate/cute_vege1.png";
import cuteVege2 from "../../../assets/img/baolinPrivate/cute_vege2.png";
import cuteMonk1 from "../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../assets/img/baolinPrivate/cute_monk2.png";


function ChingMingEventTicket() {
    const { language } = useGuestContext();
    const history = useHistory();
    const redirectToRegister = () => {
        history.push('/chingmingregister');
    };
    const location = useLocation();
    // Extracting guestId from location.state or URL search parameters
    const params = new URLSearchParams(window.location.search);
    let guestId = location.state?.guestId || params.get('guestid') || params.get('id');
    const formattedGuestId = String(guestId).padStart(4, '0');
    // const eventName = language === "English" ? "Bao Lin Chan Monastery 15th Anniversary" : "寶林禪寺15週年慶法會";
    const eventName = (
        <span>
            Medicine Buddha Repentance Service Event Ticket
        </span>
    );


    const date = "26/07/2026";
    const time = "9:30";
    const qrValue = `${process.env.REACT_APP_SERVER_URL}/event/checkin?id=${guestId}`;

    const addToCalendar = () => {
        const event = {
            start: [2026, 7, 26, 9, 30],
            end: [2026, 7, 26, 16, 30],
            title: "Bao Lin Medicine Buddha Repentance Service",
            description: `Medicine Buddha Repentance Service & Completion of Gratitude Medicine Buddha at Bao Lin Chan Monastery\\n\\nGuest ID: ${formattedGuestId}\\nEvent Ticket URL: ${window.location.origin}/chingming/event-ticket?id=${guestId}`,
            location: "Bao Lin Chan Monastery, 94A High St, Glen Iris VIC 3146",
            url: "https://chungtai.org.au/"
        };

        const formatDate = (dateArr) => {
            // YYYYMMDDTHHMMSS
            return `${dateArr[0]}${String(dateArr[1]).padStart(2, '0')}${String(dateArr[2]).padStart(2, '0')}T${String(dateArr[3]).padStart(2, '0')}${String(dateArr[4]).padStart(2, '0')}00`;
        };

        const content = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:-//Bao Lin//Events//EN',
            'BEGIN:VEVENT',
            `DTSTART:${formatDate(event.start)}`,
            `DTEND:${formatDate(event.end)}`,
            `SUMMARY:${event.title}`,
            `DESCRIPTION:${event.description}`,
            `LOCATION:${event.location}`,
            `URL:${event.url}`,
            'END:VEVENT',
            'END:VCALENDAR'
        ].join('\n');

        const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'baolin_medicinebuddha_event.ics';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const Announcement = (
        <>
            <Alert className="alert-with-icon" variant="info">
                <span
                    data-notify="icon"
                    className="nc-icon nc-bell-55"
                ></span>
                <span data-notify="message font-weight-bold">
                    溫馨提醒：本週六(13/4)寶林十五週年慶，上午8:30開放報到，請於9:30前就座。因人數眾多停車不易，精舍從上午6:45~9:30安排往返Glen Iris Station的接駁車，請盡量搭乘。精舍前High St. 和Allison Ave.禁止停車。當日不開放置物櫃，個人物品請務必隨身保管。您的Guest ID和QR code已寄到email，期待您共同參與盛會！
                </span>
                <span data-notify="message">

                </span>
            </Alert>
            <Alert className="alert-with-icon mt-1" variant="success">
                <span
                    data-notify="icon"
                    className="nc-icon nc-bell-55"
                ></span>
                <span data-notify="message">
                    Friendly reminder: Bao Lin's 15th Anniversary is on 13/4 (Sat). Check-in begins at 8:30 AM. Please be seated by 9:30 AM. Due to limited parking, shuttle service to and from Glen Iris Station runs from 6:45 AM to 9:30 AM. No parking on High St in front of Bao Lin & Allison Ave. Lockers will not be available on that day, so please keep your personal belongings with you at all times. Guest ID & QR code will be sent via email. Looking forward to your presence.
                </span>
            </Alert>
        </>
    )

    const downloadImage = () => {
        const input = document.getElementById('ticket-for-download');
        html2canvas(input, {
            scale: 1,
            logging: true,
            useCORS: true,
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            const link = document.createElement('a');
            link.href = imgData;
            link.download = `baolin-medicinebuddha-id-${guestId}.jpg` // File name for the downloaded file
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }).catch(error => {
            console.error("Error generating JPEG", error);
        });
    };

    const cardBackgroundStyle = {
        // Default background that will be applied on larger screens
        backgroundImage: `linear-gradient(to left, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 1)), url(${require("../../../assets/img/baolinPrivate/MedicineBuddha2026.jpg")})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
    };

    // Style for the lotus divider image
    const dividerStyle = {
        width: '50%', // Sets the width to match the parent container
        height: '100%', // Keeps the aspect ratio of the image
        maxWidth: '100%', // Ensures that the image doesn't exceed its original size
        // maxWidth: '100%', // Ensures that the image doesn't exceed its original size
        // display: 'block', // To prevent default inline behavior that includes white space
        // margin: 'auto' // To center the image in the available column space
    };

    const ticketContent = (
        <>
            <div id="ticket-content">

                <div className="d-flex justify-content-center mb-3">
                    {/* <img src={cuteVege1} alt="Company Logo" width="20" className="mr-3" /> */}
                    <div className="text-center">
                        <h3 className="font-weight-bold font-size-lg text-info mb-3">
                            <img src={cuteMonk2} alt="Company Logo" width="40" className="ml-3" />
                            <span className="m-4">藥師寶懺法會</span>
                            <img src={cuteMonk1} alt="Company Logo" width="40" className="mr-3" />
                        </h3>
                        <span className="font-weight-bold font-size-lg d-block">
                            {eventName}
                        </span>

                    </div>

                </div>


                {/* {Announcement} */}
                <hr style={{ borderColor: '#ddd', marginTop: 0, marginBottom: '1rem' }} />
                <Row>
                    <Col md={{ span: 4, offset: 1 }} className="d-flex flex-column justify-content-center align-items-center">

                        <Card className="bg-light text-center">
                            <CardBody>
                                <CardSubtitle className="mb-2 .text-black-50 font-weight-bold">Guest ID</CardSubtitle>
                                <span className="font-size-lg mb-0 text-center text-guest-id">
                                    {formattedGuestId}
                                </span>
                            </CardBody>
                        </Card>


                        <QRCodeCanvas value={qrValue} size={170} level={"H"} className="mt-3" />
                        <span className="font-size-md mb-0 text-center">
                            請掃碼報到
                        </span>
                        <span className="font-size-md mb-0">
                            Scan QR code to check in
                        </span>
                    </Col>

                    <Col md={{ span: 2 }} className=" d-none d-md-block">
                        <img
                            src={require("../../../assets/img/baolinPrivate/lotus_divider.png")}
                            alt="divider"
                            style={dividerStyle}
                        />
                    </Col>
                    <Col md={{ span: 4 }} className="d-flex justify-content-center">
                        <Container className="mt-5">
                            <Row>
                                <Col> {/* This will take the full width of the row by default */}
                                    <Card className="bg-light text-center">
                                        <CardBody>
                                            <span className="custom-text-lg d-block">Jul 26<sup>th</sup> </span>
                                            <span className="custom-text-lg d-block">7月26日</span>
                                            <CardSubtitle className="mb-2 .text-black-50">Sunday</CardSubtitle>
                                            <CardSubtitle className="mb-2 .text-black-50">星期日</CardSubtitle>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>

                            <Row className="justify-content-left">
                                <div className="table-responsive">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th className="text-center">Event</th>
                                                <th className="text-center">
                                                    Time
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">
                                                    <span className="d-block">藥師寶懺法會</span>
                                                    <span className="d-block">Medicine Buddha Ceremony</span>
                                                </td>
                                                <td className="text-center"> <span className="font-weight-bold ">09:30AM~04:30PM </span></td>
                                            </tr>

                                        </tbody>
                                    </Table>
                                </div>
                            </Row>

                        </Container>
                    </Col>

                </Row>


            </div>
        </>)

    const ticket = (
        <>
            <Card className="card-box mb-5 p-4" id="ticket-for-download" style={{ ...cardBackgroundStyle }}>
                {ticketContent} {/* Render the ticket content */}
            </Card>
            <Row className="mt-1">
                <Col>
                    <Button
                        className="btn-round btn-wd mr-1 "
                        style={{ fontWeight: 'bold' }}
                        href="#/"
                        type="button"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent the default anchor action
                            addToCalendar();
                        }}
                        variant="success"
                        size="md"
                        outline
                        block
                    >
                        <FontAwesomeIcon icon={faCalendar} />  {language === "English" ? "Download Calendar Event" : "下載日曆活動"}
                    </Button>
                </Col>
                <Col>
                    <Button
                        tag="a"
                        href="#/"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent the default anchor action
                            downloadImage();
                        }}
                        style={{ fontWeight: 'bold' }}
                        size="md"
                        className="btn-round btn-wd mr-1"
                        outline
                        variant="primary"
                        block
                    >
                        <FontAwesomeIcon icon={faTicket} />  {language === "English" ? "Download Ticket as JPEG" : "下載入場券"}
                    </Button>
                </Col>
                <Col>
                    <Button
                        tag="a"
                        href="#/"
                        onClick={redirectToRegister}
                        style={{ fontWeight: 'bold' }}
                        size="md"
                        className="btn-round btn-wd mr-1"
                        outline
                        variant="success"
                        block
                    >
                        {language === "English" ? "Register more" : "繼續報名"} <FontAwesomeIcon icon={faArrowRight} />
                    </Button>
                </Col>
            </Row>
        </>
    );
    return (
        <>
            <Guest>
                <div className="content d-flex align-items-center p-0">
                    <Container>
                        {ticket}

                    </Container>
                </div>

            </Guest >
        </>
    );
}

export default ChingMingEventTicket;
